import { BlockComponentFactory } from '../BlockFactory'
import Input from 'antd/lib/input'
import { TextAreaBlockProps } from './block-props.types'
import { LabelBlock } from './LabelBlock'
import { LABEL_FONT_STYLE } from '../../constants'
import { useBlockListeners } from '../BlockHooks'
import { useBlockEngine } from '../BlockEngineContext'
import { toCSSSize } from './block-utils'

export const TextAreaBlockComponent =
    BlockComponentFactory.createBlockComponent<TextAreaBlockProps>(props => {
        const {
            label,
            placeholder,
            infoText,
            value,
            required = false,
            minLength,
            maxLength,
            showCount = false,
            width,
            height,
            visibility = 'visible',
            disabled = false,
            style,
        } = props

        const isEditable = useBlockEngine().blockEngine.getEditableSignal().value

        const [onChangeListener] = useBlockListeners<(value: string | null) => void>('onChange')

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: toCSSSize(width) || '100%',
        }

        const textAreaStyle: React.CSSProperties = {
            width: '100%',
            height: toCSSSize(height) || 'auto',
            ...LABEL_FONT_STYLE,
            fontSize: '12px',
        }

        return (
            <div style={containerStyle}>
                <LabelBlock
                    label={label}
                    required={required}
                    infoText={infoText}
                    labelStyle={LABEL_FONT_STYLE}
                />
                <Input.TextArea
                    placeholder={placeholder}
                    value={value}
                    required={required}
                    disabled={!isEditable || disabled}
                    minLength={minLength}
                    maxLength={maxLength}
                    showCount={showCount}
                    style={textAreaStyle}
                    allowClear={true}
                    onChange={e => onChangeListener?.value?.(e.target.value)}
                />
            </div>
        )
    })
